import axios from 'axios'
import { REACT_APP_PERITADOR_API } from '../../config'

export async function postDirectPurchaseUsed(data){

  const response = await axios.post(`${REACT_APP_PERITADOR_API}/requests/inform`, data)
  return response.data
}